module.exports = __webpack_public_path__ + "static/img/obustavenaplaci.506228c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/obustavenaplaci.png
// module id = 0OqB
// module chunks = 0